
  var rt = require("@stylable/runtime/cjs/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "Slider2496816389",
      {"classes":{"root":"Slider2496816389__root","sliderHandle":"Slider2496816389__sliderHandle","sliderThumb":"Slider2496816389__sliderThumb","sliderHandleWrapper":"Slider2496816389__sliderHandleWrapper","markLine":"Slider2496816389__markLine","markValue":"Slider2496816389__markValue","mark":"Slider2496816389__mark","markLabel":"Slider2496816389__markLabel","sliderHandleTooltip":"Slider2496816389__sliderHandleTooltip"},"vars":{},"stVars":{"sliderPadding":"4.5px","sliderRailHeight":"3px","sliderMarginTop":"9px","sliderMarginBottom":"6px","sliderMarkLine":"6px","sliderMarkTextMarginTop":"12px","sliderMarkTextSize":"18px","sliderThumbSize":"12px","clickableAreaSize":"24px"},"keyframes":{}},
      "",
      -1,
      module.id
  );
  